import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Pagination = ({
  paginationDetails: {
    totalPages,
    currentPage,
    hasPrevPage,
    hasNextPage,
    nextPage,
    prevPage,
  },
  fetchMore,
}) => {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    setPages([]);

    for (let page = 1; page <= totalPages; page++) {
      setPages((prevState) => {
        return [...prevState, page];
      });
    }
  }, [totalPages, currentPage, hasPrevPage, hasNextPage, nextPage, prevPage]);

  return (
    <Fragment>
      <div className="pagination-wrapper pagination-wrapper-left">
        <ul className="pg-pagination">
          {hasPrevPage ? (
            <li onClick={() => fetchMore(prevPage)}>
              <Link to="#" aria-label="Previous">
                <i className="fi ti-angle-left"></i>
              </Link>
            </li>
          ) : null}

          {pages.length &&
            pages.map((page) => (
              <li
                onClick={() => fetchMore(page)}
                key={page}
                className={page === currentPage ? 'active' : null}
              >
                <Link to="#">{page}</Link>
              </li>
            ))}

          {hasNextPage ? (
            <li onClick={() => fetchMore(nextPage)}>
              <Link to="#" aria-label="Next">
                <i className="fi ti-angle-right"></i>
              </Link>
            </li>
          ) : null}
        </ul>
      </div>
    </Fragment>
  );
};

export default Pagination;
